import React from "react";
import { Navigate } from "react-router-dom";
import { getUserSession } from "../../utils/userSession";
import { routes } from "../../Constants/routes";

interface PublicRouteProps {
  children: React.ReactElement;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const accessToken = localStorage.getItem("accessToken");
  const userSession = getUserSession();

  // Verifica se o usuário está autenticado
  const isAuthenticated = !!(accessToken && userSession);

  if (isAuthenticated) {
    // Redireciona para dentro da aplicação se já estiver autenticado
    return <Navigate to={routes.OS_LIST} replace />;
  }

  return children;
};

export default PublicRoute;
